import DateNavigatorReportsClock from './DateNavigatorReportsClock';
import { useTemplate } from '../../hooks';
import DateNavigatorReportsList from './DateNavigatorReportsList';
export default function DateNavigatorReports(props: any) {
  const { tempoptions } = useTemplate();

  if (tempoptions?.calendarclock) {
    return <DateNavigatorReportsClock {...props}></DateNavigatorReportsClock>;
  }

  return <DateNavigatorReportsList {...props}></DateNavigatorReportsList>;
}
